import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { s } from './common.js';
export function ContainerComponent(props) {
    const title = s(props.config, 'title');
    const body = s(props.config, 'body');
    return (_jsxs("div", { className: "flex flex-col gap-2 rounded-xl border border-[var(--bcbb-border)] bg-[var(--bcbb-surface-2)] p-4", children: [title && _jsx("div", { className: "text-sm font-semibold text-[var(--bcbb-text)]", children: title }), body && _jsx("p", { className: "m-0 text-sm text-[var(--bcbb-text-muted)]", children: body })] }));
}
export const ContainerArchetype = {
    name: 'Container',
    label: 'Container',
    description: 'Grouping card with an optional title and body.',
    component: ContainerComponent,
    isFormArchetype: false,
    fields: {
        title: { kind: 'text', label: 'Title', optional: true },
        body: { kind: 'textarea', label: 'Body', optional: true },
    },
    defaultConfig: { title: '', body: '' },
};
